import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "imagecanvas-main" }
const _hoisted_2 = { class: "imagecanvas-container" }
const _hoisted_3 = { class: "imagecanvas-image-canvas-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "canvas-toolbar"
}
const _hoisted_6 = ["src", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.imgSrc,
          class: "image",
          onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.initCanvas && _ctx.initCanvas(...args)))
        }, null, 40, _hoisted_4),
        _createElementVNode("canvas", {
          ref: "canvas",
          class: _normalizeClass(["absolute-canvas", { 'no-pointer-events': _ctx.readOnly }]),
          onPointerdown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startDrag && _ctx.startDrag(...args))),
          tabindex: "0"
        }, null, 34),
        (_ctx.readOnly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("img", {
                class: "toolbar-btn",
                src: _ctx.showPoints ? require('../assets/enableView.png') : require('../assets/disableView.png'),
                title: _ctx.showPoints ? 'Ocultar pontos' : 'Mostrar pontos',
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.togglePoints && _ctx.togglePoints(...args))),
                alt: "toggle points"
              }, null, 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}